module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/space-1-large-4693702f56620294df5a9405bca24bc3.jpg";